import { FormLabel, ListItem } from "@mui/material";
import SoftTagInput from "components/SoftTagInput";
import { useContext } from "react";
import { ComponentPropsContext, ComponentPropsContextApi } from "layouts/Flow Designer/context";
import SoftTypography from "components/SoftTypography";
import { combineStyles } from "helpers/common";
import { useSelector } from "react-redux";

const styles = {
  w100: {
    width: "100%"
  },
  listItemMargin_t16: {
    marginTop: "16px"
  },
  asterisk: {
    color: "#ff667c"
  }
};

export const SimpleTag = ({ action, fieldValue, allowEditWorkflow }) => {
  const { actionForm, formErrors } = useContext(ComponentPropsContext);
  const { setActionForm, setFormErrors } = useContext(ComponentPropsContextApi);
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";

  const handleOnChange = (values) => {
    if (isFlowActive || !allowEditWorkflow) return;

    setActionForm({
      ...actionForm,
      [action.field]: {
        value: values
      }
    });

    if (values.length) {
      setFormErrors((prev) => prev.filter((item) => item !== action.field));
    }
  };

  return (
    <ListItem
      className={`simple-tag ${formErrors.includes(action.field) && "error"}`}
      sx={{
        ...combineStyles(styles.w100, styles.listItemMargin_t16),
        display: "block"
      }}
    >
      <FormLabel sx={{ fontSize: "12px", paddingLeft: "12px", display: "block" }}>
        {action.label} {action.isRequired ? <span style={{ color: "#ff667c" }}>*</span> : ""}
      </FormLabel>
      <SoftTagInput
        placeholder={action.placeholder}
        value={fieldValue}
        onChange={handleOnChange}
        disabled={isFlowActive || !allowEditWorkflow}
      />
      {formErrors.includes(action.field) && (
        <SoftTypography
          sx={{
            color: "#ff667c",
            fontSize: "12px"
          }}
        >
          {action.label} is required
        </SoftTypography>
      )}
    </ListItem>
  );
};
